
import { NgModule } from "@angular/core";
import { Routes, RouterModule, Router } from '@angular/router';

import { AuthGuard } from "./core/auth.guard";
import { AuthService } from './services/auth.service';

const routes: Routes = [
  {
    path: "account",
    loadChildren: () =>
      import("./modules/authentication/authentication.module").then(
        (m) => m.AuthenticationModule
      ),
    data: { title: "Account" },
  },
  {
    path: "onboarding",
    loadChildren: () =>
      import("./modules/onboarding/onboarding.module").then(
        (m) => m.OnboardingModule
      ),
    canActivate: [AuthGuard],
    data: { title: "Onboarding" },
  },
  {
    path: "priceyard",
    loadChildren: () =>
      import("./modules/priceyard/priceyard.module").then(
        (m) => m.PriceyardModule
      ),
    canActivate: [AuthGuard],
    data: { title: "Priceyard" },
  },
  {
    path: "shipyard",
    loadChildren: () =>
      import("./modules/shipyard/shipyard.module").then(
        (m) => m.ShipyardModule
      ),
    canActivate: [AuthGuard],
    data: { title: "Shipyard" },
  },
  {
    path: "detail",
    loadChildren: () =>
      import("./modules/detail/detail.module").then(
        (m) => m.DetailModule
      ),
    canActivate: [AuthGuard],
    data: { title: "Shipyard" },
  },
  {
    path: "forecasting",
    loadChildren: () =>
      import("./modules/planyard/planyard.module").then(
        (m) => m.PlanyardModule
      ),
    canActivate: [AuthGuard],
    data: { title: "Forecasting" },
  },
  {
    path: "inventory",
    loadChildren: () =>
      import("./modules/inventory/inventory.module").then(
        (m) => m.InventoryModule
      ),
    canActivate: [AuthGuard],
    data: { title: "Inventory" },
  },
  // logistic start 
  {
    path: "logistic",
    loadChildren: () =>
      import("./modules/logistic/logistic.module").then(
        (m) => m.LogisticModule
      ),
    canActivate: [AuthGuard],
    data: { title: "Logistic" },
  },
  // logistic end 
  {
    path: "detail",
    loadChildren: () =>
      import("./modules/detail/detail.module").then(
        (m) => m.DetailModule
      ),
    canActivate: [AuthGuard],
    data: { title: "Shipyard" },
  },
  {
    path: "integrations",
    loadChildren: () =>
      import("./modules/integrations/integrations.module").then(
        (m) => m.IntegrationsModule
      ),
    canActivate: [AuthGuard],
    data: { title: "Integrations" },
  },
  {
    path: "channels",
    loadChildren: () =>
      import("./modules/channels/channels.module").then(
        (m) => m.ChannelsModule
      ),
    canActivate: [AuthGuard],
    data: { title: "Settings" },
  },
  {
    path: "analytics",
    loadChildren: () =>
      import("./modules/analytics/analytics.module").then(
        (m) => m.AnalyticsModule
      ),
    canActivate: [AuthGuard],
    data: { title: "Analytics" },
  },
  {
    path: "settings",
    loadChildren: () =>
      import("./modules/settings/settings.module").then(
        (m) => m.SettingsModule
      ),
    canActivate: [AuthGuard],
    data: { title: "Settings" },
  },
  {
    path: "dashboard",
    loadChildren: () =>
      import("./modules/dashboard/dashboard.module").then(
        (m) => m.DashboardModule
      ),
    canActivate: [AuthGuard],
    data: { title: "Dashboard" },
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {
  constructor(private router: Router, private authService: AuthService) {
    this.authService.userInfo$.subscribe((res) => {
      if(res){
        const config = router.config;
        config.push({ path: "**", redirectTo: this.authService.initialLoadRedirect(res, null), pathMatch: "full" });
        router.resetConfig(config);
      }
    });
  };
}
